 window.addEventListener(
    "message",
    (event) => {
      if (event.origin !== "https://saas.haut.ai") return;
      // console.log(JSON.stringify(event.data))
      if(event.data && event.data.resultData){
        window.localStorage.setItem('haut_result', JSON.stringify(event.data)) 
        if(!window.location.href.includes('pages/result')){
          window.location.href = '/pages/result'
        }else{
          window.location.reload()
        }
        
      }
      
      // …
    },
    false,
  );


 jQuery(document).ready(function($){
   var res = localStorage.getItem('haut_result')
   var selected_frame = localStorage.getItem('selected_frame')
   
   var count = 1
   var prods = []
   if($('.smashing-haut-result').length > 0 && res){
       
        res = JSON.parse(res)
        var final_res = res.resultData
        var svg = '';
        var html = '';
        var append_url = ''
        var age, eye_age, skin, eye_bags, uni, red, wrink, translucency, pores, pigmentation, hydration = ''

     
        if (final_res && final_res.result){
          
          if(final_res.result.metrics && final_res.result.metrics.length > 0){
            $('.smashing-haut-result').html('<div class="overview-main-wrap"><div class="smashing-inner-slider"></div></div>')
            html = '<div class="overview-wrap"><h3 class="haut-header">SKIN Summary</h3>';
            
            
            final_res.result.metrics.forEach(function(val, i){
              if(val.result.area_results && val.result.area_results.length > 0){
                
                if(val.result.area_results){
                  if(val.result.area_results[0]){

                    switch(val.result.area_results[0].main_metric.name){
                      case 'Translucency score':
                        translucency = val.result.area_results[0].main_metric.value
                        break;
                      case 'Hydration Score':
                        hydration = val.result.area_results[0].main_metric.value
                        break;
                      case 'Pores Score':
                        pores = val.result.area_results[0].main_metric.value
                        break;
                      case 'Pigmentation score':
                        pigmentation = val.result.area_results[0].main_metric.value
                        break;
                      case 'Eye Age':
                        eye_age = val.result.area_results[0].main_metric.value
                        break;
                      case 'Perceived Age':
                        age = val.result.area_results[0].main_metric.value
                        break;
                      case 'Skin tone':
                        skin = val.result.area_results[0].main_metric.value
                        break;
                      case 'Eye Area Condition':
                        eye_bags = val.result.area_results[0].main_metric.value
                        break;
                      case 'Uniformness Score':
                        uni = val.result.area_results[0].main_metric.value
                        break;
                      case 'Redness Score':
                        red = val.result.area_results[0].main_metric.value
                        break;
                      case 'ITA score':
                        wrink = val.result.area_results[0].main_metric.value
                        break;
                    }
                  }
                }
              }
            })

            
              

            if(eye_age != '' || age != ''){
               html += '<div class="ov-item eye-age"><span>Perceived age/eye age';
               html += '</span><span class="metric-label">' + age + '/' + eye_age + ' years</span></div>';
            }

            if(skin != ''){
               html += '<div class="ov-item skin-tone-wrap"><span> Skin Tone';
               html += '</span><div class="ov-item-graph-wrap"><span style="margin-bottom: 15px;display: inline-flex;">' + skin + '</span><div class="ov-item-graph" style="overflow: visible;">';
               html += '<span class="skin-item ' + (skin == 'Very Light' ? 'active' : '') + ' Very Light"></span>';
               html += '<span class="skin-item ' + (skin == 'Light' ? 'active' : '') + ' Light"></span>';
               html += '<span class="skin-item ' + (skin == 'Intermediate' ? 'active' : '') + ' Intermediate"></span>';
               html += '<span class="skin-item ' + (skin == 'Tan' ? 'active' : '') + ' Tan"></span>';
               html += '<span class="skin-item ' + (skin == 'Brown' ? 'active' : '') + ' Brown"></span>';
               html += '<span class="skin-item ' + (skin == 'Dark' ? 'active' : '') + ' Dark"></span>';
               html += '</div></div></div>';
            }

            if(eye_bags != ''){
               html += '<div class="ov-item eye-age"><span>Eye bags';
               html += '</span><div class="ov-item-graph-wrap"><span>' + eye_bags + '</span><div class="ov-item-graph"><span style="width:' + eye_bags + '%"></span></div></div></div>';
            }

            if(uni != ''){
               html += '<div class="ov-item eye-age"><span>Uniformness';
               html += '</span><div class="ov-item-graph-wrap"><span>' + uni + '</span><div class="ov-item-graph"><span style="width:' + uni + '%"></span></div></div></div>';
            }

            if(red != ''){
               html += '<div class="ov-item eye-age"><span>Redness';
               html += '</span><div class="ov-item-graph-wrap"><span>' + red + '</span><div class="ov-item-graph"><span style="width:' + red + '%"></span></div></div></div>';
            }

            if(wrink != ''){
               html += '<div class="ov-item eye-age"><span>Wrinkles';
               html += '</span><div class="ov-item-graph-wrap"><span>' + wrink + '</span><div class="ov-item-graph"><span style="width:' + wrink + '%"></span></div></div></div>';
            }

            if(translucency != ''){
               html += '<div class="ov-item eye-age"><span>Translucency';
               html += '</span><div class="ov-item-graph-wrap"><span>' + translucency + '</span><div class="ov-item-graph"><span style="width:' + translucency + '%"></span></div></div></div>';
            }

            if(pores != ''){
               html += '<div class="ov-item eye-age"><span>Pores';
               html += '</span><div class="ov-item-graph-wrap"><span>' + pores + '</span><div class="ov-item-graph"><span style="width:' + pores + '%"></span></div></div></div>';
            }

            if(pigmentation != ''){
               html += '<div class="ov-item eye-age"><span>Pigmentation';
               html += '</span><div class="ov-item-graph-wrap"><span>' + pigmentation + '</span><div class="ov-item-graph"><span style="width:' + pigmentation + '%"></span></div></div></div>';
            }

            if(hydration != ''){
               html += '<div class="ov-item eye-age"><span>Hydration';
               html += '</span><div class="ov-item-graph-wrap"><span>' + hydration + '</span><div class="ov-item-graph"><span style="width:' + hydration + '%"></span></div></div></div>';
            }
            
            html += '</div><h3 class="haut-header">Face Maps</h3>';
            $('.overview-main-wrap').prepend(html)
            final_res.result.metrics.forEach(function(val, i){
              if(val.result.masks_restored && val.result.area_results && val.result.area_results.length > 0){
                 $('.smashing-inner-slider').append('<div id="holder-img' + count + '" class="holder-img "><img src="' + res.resultData.image + '" alt=""></div>')
                 svg = document.querySelector('#holder-img' + count).appendChild(document.createElementNS("http://www.w3.org/2000/svg", "svg"));
      
                 svg.setAttribute("width",'100%');
                 svg.setAttribute("height",'100%');
                
               
                 val.result.masks_restored.forEach(function(v){
                   generate(v, svg);  
                 })

                if(val.result.area_results){
                  if(val.result.area_results[0]){
                    let nm = val.result.area_results[0].main_metric.name;
                    if(nm){
                      nm = nm.replace('score', '')
                      nm = nm.replace('Score', '')
                    }
                    html = '<div class="st-wrap">';
                    html += '<div class="st-name">';
                    html += nm;
                    html += '</div>';

                    html += '<div class="st-score-alt"><span>';
                    html += val.result.area_results[0].main_metric.value;
                    html += '</span>/<span>100</span></div></div>';
                    $('#holder-img' + count).append(html)
                  }
                  
                }
               }
      
               
               count++
            })
            
            $('.smashing-inner-slider').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                speed: 500,
                variableWidth: true,
                prevArrow: '<a href="#" class="arr-left"><img src="https://cdn.shopify.com/s/files/1/0765/6167/8609/files/arr-right.svg?v=1709642611" /></a>',
                nextArrow: '<a href="#" class="arr-right"><img src="https://cdn.shopify.com/s/files/1/0765/6167/8609/files/arr-left.svg?v=1709642611" /></a>',
                responsive: [
                      {
                          breakpoint: 980, // tablet breakpoint
                          settings: {
                              slidesToShow: 3,
                              variableWidth: false,
                              slidesToScroll: 1
                          }
                      },
                      {
                          breakpoint: 480, // mobile breakpoint
                          settings: {
                              slidesToShow: 1,
                              variableWidth: false,
                              slidesToScroll: 1
                          }
                      }
                  ]
            });

          }

          var with_prof = false;
          if(final_res.result.products && final_res.result.products.length > 0){
            final_res.result.products.forEach(function(val, i){
              if(val.inventory_item){
                 if(val.inventory_item.vendor_code){
                    prods.push('id:' + val.inventory_item.vendor_code)
                 } 
                
              }
            })

            switch(selected_frame){
              case 'Anti-aging':
                  prods.push('id:9101846610193');
                break;
              case 'Acne':
                  prods.push('id:9101847429393');
                  prods.push('id:9101848150289');
                break;
              case 'Anti-aging':
                  prods.push('id:9101845201169');
                  prods.push('id:9101851427089');
                break;
              case 'Sensitive Skin':
                  prods.push('id:9101845561617');
                break;
              case 'Pigmentation':
                  prods.push('id:9101845201169');
                  prods.push('id:9101851427089');
                break;
              case 'Fine Lines & Pigmentation':
                  prods.push('id:9101845201169');
                  prods.push('id:9101851427089');
                break;
              case 'Scarring':
                  prods.push('id:9101845201169');
                  prods.push('id:9101851427089');
                break;
            }

            if(prods.length > 0){
              var prods_filtered = prods.join(" OR ");
              var settings = {
                "url": "https://dermaquest-clinical.myshopify.com/api/2024-01/graphql.json",
                "method": "POST",
                "timeout": 0,
                "headers": {
                  "Content-Type": "application/json",
                  "X-Shopify-Storefront-Access-Token": "a89443a741cac17d02a43213156a93b8"
                },
                "data": JSON.stringify({
                    "query": "query { products(first: 50, query: \"" + prods_filtered + "\") {edges {node {id,title,description,handle,featuredImage{url},productType,variants(first: 1){edges {node {id}}},metafields(identifiers: [{namespace: \"custom\", key: \"color_scheme_gradient_1\"},{namespace: \"custom\", key: \"color_scheme_gradient_2\"},{namespace: \"custom\", key: \"hover_texture\"},{namespace: \"custom\", key: \"hover_who_it_s_for\"},{namespace: \"custom\", key: \"hover_results\"},{namespace: \"custom\", key: \"collection\"},{namespace: \"custom\", key: \"dq_system_reference\"}]) {namespace,key,value}}}} }"
                }),
              };
              
              $.ajax(settings).done(function (response) {
                var data = response.data.products.edges
                var gradient1, gradient2, hover_texture, hover_who_it_s_for, hover_results,collection,dermaquest_system_reference = '';
                var section_html = [
                  {
                    "num": "01",
                    "title": "Cleanse",
                    "description": "Gentle, hypoallergenic cleansers remove toxins and impurities deep within the pores, while removing layers of dead skin cells.",
                    "img_url": "//dermaquest-clinical.myshopify.com/cdn/shop/files/51cbf75b2f3756efbbfbffb494fb7890.png?v=1700251792"
                  },
                  {
                    "num": "02",
                    "title": "Hydrate",
                    "description": "Maximize the H2O healthy skin needs with humectants that draw and retain water to keep the top dermal layers from drying out.",
                    "img_url": "//dermaquest-clinical.myshopify.com/cdn/shop/files/51cbf75b2f3756efbbfbffb494fb7890.png?v=1700251792"
                  },
                  {
                    "num": "03",
                    "title": "Repair",
                    "description": "Restore the damage done by environmental factors to rejuvenate skin and reverse or minimize the effects of aging.",
                    "img_url": "//dermaquest-clinical.myshopify.com/cdn/shop/files/51cbf75b2f3756efbbfbffb494fb7890.png?v=1700251792"
                  },
                  {
                    "num": "04",
                    "title": "Correct",
                    "description": "Address blemishes, blotches, dark circles, acne, and other minor imperfections in skin tone and texture.",
                    "img_url": "//dermaquest-clinical.myshopify.com/cdn/shop/files/51cbf75b2f3756efbbfbffb494fb7890.png?v=1700251792"
                  },
                  {
                    "num": "05",
                    "title": "Moisturize",
                    "description": "Occlusives, emollients, and protein rejuvenators that restore skin’s healthy balance of natural oils and help keep skin lush and hydrated.",
                    "img_url": "//dermaquest-clinical.myshopify.com/cdn/shop/files/51cbf75b2f3756efbbfbffb494fb7890.png?v=1700251792"
                  },
                  {
                    "num": "06",
                    "title": "Protect",
                    "description": "The most effective care is preventative care, making these defensive products essential for any serious skincare regimen.",
                    "img_url": "//dermaquest-clinical.myshopify.com/cdn/shop/files/51cbf75b2f3756efbbfbffb494fb7890.png?v=1700251792"
                  }
                ]
                var profCount = 0;
                var prodCount = 0;
                if(!response.data.products.edges){
                  return false
                }

                html = '<div class="result-products-wrapper">'
                html += '<div class="rpw-buttons-wrap"><a href="#rpw-treatments-wrap" class="button tb-btn custom-button-outline active">Professional Treatments</a><a href="#rpw-prods-wrap" class="button tb-btn custom-button-outline">Home Care Products</a></div>'
                html += '<div class="rpw-content-wrapper">'
                
                html += '<div class="rpw-content-wrapper">'

                if(data && data.length > 0){
                  data.forEach((val) => {
                    if(val.node.productType == 'Professional'){
                      
                      profCount = profCount + 1
                    }else{
                      prodCount = prodCount + 1
                    }
                  })
                }
                // Treatments
                
                html += '<div class="border-item-wrap"><h4 class="rpw-header w-border">Professional Treatment Recommendations</h4>' 
                html += '<div class="rpw-desc-header">Please consult your local dermaquest clinic for a detailed treatment plan.</div>' 
                html += '<div class="rpw-content-item active" id="rpw-treatments-wrap">'
                
                if(profCount){
                  html += '<product-list class="product-list" role="region" aria-live="polite">'
                  data.forEach((val) => {

                    if(val.node.productType == 'Professional'){
                        if(val.node.metafields && val.node.metafields.length > 0){
                          
                          val.node.metafields.forEach((innerVal) => {
                            if(innerVal){
                              switch(innerVal.key){
                                case "color_scheme_gradient_1": 
                                  gradient1 = innerVal.value
                                  break;
                                case "color_scheme_gradient_2": 
                                  gradient2 = innerVal.value
                                  break;
                                case "hover_texture": 
                                  hover_texture = innerVal.value
                                  break;
                                case "hover_who_it_s_for": 
                                  hover_who_it_s_for = innerVal.value
                                  break;
                                case "hover_results": 
                                  hover_results = innerVal.value
                                  break;
                                case "collection": 
                                  collection = innerVal.value
                                  break;
                                
                              }
                            }
                            
                          })
                        }
                        if(collection && typeof collection == 'string'){ collection = JSON.parse(collection) }
                        html += generateHTML(val, gradient1, gradient2, hover_texture, hover_who_it_s_for, hover_results, collection, 'professional')
                        append_url += (val.node.title ? '&treatment_prod_title_'+counter+'='+val.node.title : '');
                        append_url += (val.node.featuredImage && val.node.featuredImage.url ? '&treatment_prod_image_'+counter+'='+val.node.featuredImage.url : '');
                        append_url += (val.node.handle ? '&treatment_prod_url_'+counter+'=/products/'+val.node.handle : '');
                    }
                    
                  })
                  html += '</product-list>'
                }else{
                  html += '<h4 class="no-recommendation">No recommendations at this time.</h4>' 
                }
                html += '</div></div>'
                html += '<div class="haut-bottom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none"><g filter="url(#filter0_b_1702_4742)"><circle cx="16.5" cy="16.5" r="16.5" transform="rotate(90 16.5 16.5)" fill="white" fill-opacity="0.5"/><circle cx="16.5" cy="16.5" r="16" transform="rotate(90 16.5 16.5)" stroke="#CCCCCC"/></g><path d="M16 11L16 22.5M16 22.5L21.5 18M16 22.5L11 18" stroke="black" stroke-width="1.5"/><defs><filter id="filter0_b_1702_4742" x="-4" y="-4" width="41" height="41" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="2"/><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1702_4742"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1702_4742" result="shape"/></filter></defs></svg></div>'
                // Products
                
                html += '<div class="" id="rpw-prods-wrap">'
               
                if(prodCount){
                  var counter = 1;
                  var ct = 1;
                  section_html.forEach((sh_val) => {
                    html += '<div class="dq_step_item" >'
                    html += '<div class="dq_step_item_header" ><span class="ds2"><span>Personalized Home Care:</span>' + sh_val.title + '</span><span class="ds1">' + sh_val.num + '</span></div>'
                    html += '<div class="dq_step_item_desc rte" >' + sh_val.description + '</div>'
                    html += '<product-list class="product-list" role="region" aria-live="polite">'
                    counter = 1
                    data.forEach((val) => {
                      if(val.node.productType != 'Professional' && counter < 3){
                        if(val.node.metafields && val.node.metafields.length > 0){
                          
                          val.node.metafields.forEach((innerVal) => {
                            if(innerVal){
                              switch(innerVal.key){
                                case "color_scheme_gradient_1": 
                                  gradient1 = innerVal.value
                                  break;
                                case "color_scheme_gradient_2": 
                                  gradient2 = innerVal.value
                                  break;
                                case "hover_texture": 
                                  hover_texture = innerVal.value
                                  break;
                                case "hover_who_it_s_for": 
                                  hover_who_it_s_for = innerVal.value
                                  break;
                                case "hover_results": 
                                  hover_results = innerVal.value
                                  break;
                                case "collection": 
                                  
                                  collection = innerVal.value
                                  break;
                                case "dq_system_reference": 
                                  dq_system_reference = innerVal.value
                                  if(Array.isArray(dq_system_reference)){
                                    dq_system_reference = dq_system_reference[0]
                                  }else{
                                    if(dq_system_reference){ 
                                      dq_system_reference = JSON.parse(dq_system_reference) 
                                      dq_system_reference = dq_system_reference[0]                    
                                    }
                                  }
                                  break;
                              }
                            }
                            
                          })

                          
                        }
                        if(collection && typeof collection == 'string'){ collection = JSON.parse(collection) }
                        if(sh_val.title == dq_system_reference){
                          html += generateHTML(val, gradient1, gradient2, hover_texture, hover_who_it_s_for, hover_results, collection)
                          let text_small = sh_val.title.toLowerCase()
                          append_url += (val.node.title ? '&'+text_small+'_prod_title_'+counter+'='+val.node.title : '');
                          append_url += (val.node.featuredImage && val.node.featuredImage.url ? '&'+text_small+'_prod_image_'+counter+'='+val.node.featuredImage.url : '');
                          append_url += (val.node.handle ? '&'+text_small+'_prod_url_'+counter+'=/products/'+val.node.handle : '');
                          counter = counter + 1;
                        }
                      }  
                    })

                    
                    html += '</product-list>'
                    html += '</div>'
                    ct = ct + 1;
                    if(ct <= 6){
                      html += '<div class="haut-bottom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none"><g filter="url(#filter0_b_1702_4742)"><circle cx="16.5" cy="16.5" r="16.5" transform="rotate(90 16.5 16.5)" fill="white" fill-opacity="0.5"/><circle cx="16.5" cy="16.5" r="16" transform="rotate(90 16.5 16.5)" stroke="#CCCCCC"/></g><path d="M16 11L16 22.5M16 22.5L21.5 18M16 22.5L11 18" stroke="black" stroke-width="1.5"/><defs><filter id="filter0_b_1702_4742" x="-4" y="-4" width="41" height="41" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImageFix" stdDeviation="2"/><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1702_4742"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1702_4742" result="shape"/></filter></defs></svg></div>'
                    }
                  })
                  
                }else{
                  html += '<h4 class="no-recommendation">No recommendations at this time.</h4>' 
                }
                
                html += '</div>'

                html += '</div>'
                
                html += '</div>'
                html += '</div>'

                $('.smashing-haut-result').append(html)


                // var a = setInterval(function(){
                //   // console.log('aaa')
                
                //   if($('#fillout-wrap iframe').length > 0){
                //     var src = $('#fillout-wrap').find('iframe').attr('src')
                    
                //     src = src + '&skintone='+ skin +'&eye_area_condition='+ eye_bags +'&eye_age='+ eye_age +'&perceived_age='+ age +'&uniformness_score='+ uni +'&redness_score='+ red +'&ita_score='+ wrink +'&product1_title='+ skin +'&product1_url='+ skin 
                //     src = src + append_url

                //     var selected_frame = window.localStorage.getItem('selected_frame')
                //     if(selected_frame && selected_frame != ''){
                //       src = src + '&skin_concern=' + selected_frame;
                //     }
                    
                //     var affiliate_email = window.localStorage.getItem('affiliate_email')
                //     if(affiliate_email && affiliate_email != ''){
                //       src = src + '&affiliate_email=' + affiliate_email;
                //       $('#fillout-wrap').find('iframe').attr('src', src) 
                //     }else{
                //       $('#fillout-wrap').find('iframe').attr('src', src)  
                //     }
                    
                //     clearInterval(a)
                    
                //   }
                
                // }, 300)

              //   $('.product-list').slick({
              //     slidesToShow: 4,
              //     slidesToScroll: 1,
              //     dots: false,
              //     arrows: true,
              //     speed: 500,
              //     variableWidth: true,
              //     prevArrow: '<a href="#" class="arr-left"><img src="//dermaquest-clinical.myshopify.com/cdn/shop/t/9/assets/arrow-left.svg" /></a>',
              //     nextArrow: '<a href="#" class="arr-right"><img src="//dermaquest-clinical.myshopify.com/cdn/shop/t/9/assets/arrow-right.svg" /></a>'
              // });

              //   if ($( window ).width() >= 992) {
              //     var h = $('.result-products-wrapper').height();
          		  // var controller = new ScrollMagic.Controller();
              //     var scene = new ScrollMagic.Scene({triggerElement: ".result-products-wrapper", duration: h})
              //                 .setPin(".overview-main-wrap")
              //                 .offset(300)
              //                 .addTo(controller);
              //   }
                
              	
              });
            }
          }
        }
       

        
   }

   $('body').on('click', '.rpw-buttons-wrap a', function(e){
     e.preventDefault()
     var href = $(this).attr('href');
     $(this).addClass('active').siblings('a').removeClass('active')
     $('.rpw-content-item').removeClass('active')
     $(href).addClass('active')
   })

   function generateHTML (val, gradient1 = '', gradient2 = '', hover_texture = '', hover_who_it_s_for = '', hover_results = '', collection = [], type = 'default'){
      var html = ''
      var vid = ''
      var pid = ''
      html += '<div class="item" >'
      html += '<product-card class="product-card product-card--blends  bg-custom text-custom" >'
      html += '<div class="product-card__figure">'
      html += '<a href="/products/' + val.node.handle + '" data-instant="">'
      html += '<img src="'+ (val.node.featuredImage && val.node.featuredImage.url ? val.node.featuredImage.url : '') +'" loading="lazy" class="product-card__image product-card__image--primary  aspect-tall"></a>'
      html += '<div class="product-card-hover_wrap" onclick="window.location.href=\'/products/' + val.node.handle + '\'">'
      html += '<div class="pch-top">'
      html += '<h4>'+ (val.node.title ? val.node.title : '') +'</h4>'
      html += '<div class="pch-gradient" style="border-radius: 5px;background: linear-gradient(90deg, '+ gradient1 +' 0%, '+ gradient2 +' 100%);"></div>'
      html += '</div>'
      html += '<div class="pch-bottom">'
      html += '<div class="pch-bottom-text">'
      
      // if(hover_texture && hover_texture != ''){
      //   html += '<div>'
      //   html += '<h5>TEXTURE</h5>'
      //   html += '<div>' + hover_texture + '</div>'
      //   html += '</div>'
      // }
      
      if(hover_who_it_s_for && hover_who_it_s_for != ''){
        html += '<div>'
        html += '<h5>WHO IT’S FOR</h5>'
        html += '<div>' + hover_who_it_s_for + '</div>'
        html += '</div>'
      }
      
      if(hover_results && hover_results != ''){
        html += '<div>'
        html += '<h5>RESULTS</h5>'
        html += '<div>' + hover_results + '</div>'
        html += '</div>'
      }


      if(type == 'professional'){
        html += '<a class="button" style="margin-top: 15px;" href="/pages/clinic-locator">Find A Clinic</a>'
      }else{
        pid = val.node.id.replace('gid://shopify/Product/', '')
        if(val.node.variants && val.node.variants.edges[0].node.id){
          vid = val.node.variants.edges[0].node.id.replace('gid://shopify/ProductVariant/', '')
        }
        html += '<form method="post" action="/cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form">'
        html += '<input type="hidden" name="form_type" value="product">'
        html += '<input type="hidden" name="utf8" value="✓">'
        html += '<input type="hidden" name="id" value="'+vid+'">'
        html += '<input type="hidden" name="quantity" value="1">'
        html += '<input type="hidden" name="product-id" value="' + pid + '">'
        html += '<button type="submit" class="button" is="custom-button">'
        html += '<div style="transform: translateY(0px); opacity: 1;">Add to Cart</div>'
        html += '<span class="button__loader" style="transform: translateY(-10px); opacity: 0;">'
        html += '<span style="opacity: 1;"></span>'
        html += '<span style="opacity: 1;"></span>'
        html += '<span style="opacity: 1;"></span>'
        html += '</span>'
        html += '</button>'
        html += '</form>'
      }
      
      html += '</div>'
      html += '<div class="pch-bottom-image">'
      html += '</div>'
      html += '</div>'
      html += '</div>'
      html += '<div class="wrap-gradient">'
      html += '<div class="pch-gradient" style="border-radius: 5px;background: linear-gradient(90deg,'+ gradient1 +' 0%, '+ gradient2 +' 100%);"></div>'
      html += '</div>'
      html += '</div>'
      html += '<div class="product-card__info "><div class="v-stack gap-0.5 w-full ">'
      html += '<p class="prod-card-collection">' + (collection.length > 0 ? collection[0] : '')  + '</p>'
      html += '<span class="product-card__title"><a href="/products/' + val.node.handle + '" class="bold" data-instant="">'+ (val.node.title ? val.node.title : '') +'</a></span>'
      html += '</div>'
      html += '</div>'
      html += '</product-card>'
      html += '</div>' 

     return html
   }

   function generate(DATA, svg) {

      //Set viewBox
     
      if (DATA.view_box) {
          svg.setAttribute("viewBox", DATA.view_box);
      }
      if(DATA.features){
        DATA.features.forEach(function(d){   
          d.geometry.coordinates.forEach(function(c){
              let object = null;

              //Polygon
              if (d.geometry.type == 'MultiPolygon') {
                  object = svg.appendChild(document.createElementNS("http://www.w3.org/2000/svg", "polygon"));      
                  object.setAttribute("points",c[0]);
              }      

              //Point
              if (d.geometry.type == 'MultiPoint') {
                  object = svg.appendChild(document.createElementNS("http://www.w3.org/2000/svg", "circle"));      
                  object.setAttribute("cx",c[0]);
                  object.setAttribute("cy",c[1]);
                  object.setAttribute("r",c[2]);
              }

              //intensity
              if (d.geometry.intensity) {
                  object.style.opacity = d.geometry.intensity;
              }

              //fill
              if (DATA.fill && object) {
                  object.style.fill = DATA.fill;
              }
          });
      });
      }
      
  }
 });